import type { ManageAPI } from "~/manage-api/types";

export function getOffersByStream(offers: ManageAPI.Offer[], stream: Number, includeOrphans = false) {
  function hasPublicationStream(offer: ManageAPI.Offer, id: Number) {
    var streams = offer.publicationStreams || [];
    return streams.filter((stream) => stream.id == id).length;
  }

  function hasNoPublicationStreams(offer: ManageAPI.Offer) {
    var streams = offer.publicationStreams || [];
    return streams.length == 0;
  }
  return offers
    .filter((offer) => {
      return !includeOrphans
        ? hasPublicationStream(offer, stream)
        : hasPublicationStream(offer, stream) || hasNoPublicationStreams(offer);
    })
    .sort(() => Math.random() - 0.5);
}